export default {
  "article.back": "← Zurück zur Startseite",
  "article.reading_time": "Lesezeit: 8 Minuten",
  "article.published": "Veröffentlicht am 15. Juli 2026",
  "article.category": "Guide",
};